module.exports = __webpack_public_path__ + "img/视频1.f1c60cb9.png";